// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_COMPLAINT_TITLE = "Nahlasujem nevhodn\u00fd \u010dl\u00e1nok";
export const FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM = "Nahlasujem nevhodn\u00fa odpove\u010f";
export const MESSAGE_DOES_NOT_BELONG_TO_FORUM = "Nahlasujem nevhodn\u00fd pr\u00edspevok";
export const PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahlasujem nevhodn\u00fd koment\u00e1r";
export const PHOTOBLOG_POST_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahlasujem nevhodn\u00fd pr\u00edspevok";
